// ABOUTME: Icon of the bulk change stepper's active step: its number in a filled circle of the secondary colour.
// ABOUTME: The other steps keep the stepper's own icons (grey number, check mark when done).

import { Box, Typography } from '@ds/coolshop';

export function StepNumberIcon({ number }: { number: number }) {
    return (
        <Box
            width={24}
            height={24}
            borderRadius="50%"
            bgcolor="secondary.main"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Typography variant="caption" color="secondary.contrastText">
                {number}
            </Typography>
        </Box>
    );
}
